<script lang="ts">
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher<{
        selectEmote: string;
    }>();

    let selectedEmote: string = "";

    const onEmotePick = () => {
        dispatch("selectEmote", selectedEmote);
        selectedEmote = "emotes";
    };
</script>

<!-- svelte-ignore a11y-no-onchange -->
<select id="emote-picker" bind:value={selectedEmote} on:change={onEmotePick} aria-label="emote-select">
    <option value="emotes" style="display:none">Emotes</option>
    <optgroup label="Happy">
        <option value="happy">Happy</option>
        <option value="plusone">+1</option>
        <option value="lol">Laughing</option>
        <option value="sunglasses">Sunglasses</option>
    </optgroup>
    <optgroup label="Sad">
        <option value="sad">Sad</option>
        <option value="cry">Cry</option>
    </optgroup>
    <optgroup label="Surprise">
        <option value="boom">Vine boom</option>
    </optgroup>
    <optgroup label="Angry">
        <option value="angry">Angry</option>
        <option value="avgn">AVGN</option>
    </optgroup>
    <optgroup label="Bored">
        <option value="sleep">Sleep</option>
    </optgroup>
    <optgroup label="Silly">
        <option value="chungus">Big Chungus</option>
        <option value="vault">Vault</option>
        <option value="amogus">Amogus</option>
        <option value="hopon">Hop on gnummikub</option>
    </optgroup>
</select>

<style>
    #emote-picker {
        min-width: 112px;
    }
</style>
